import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "dashboard__container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" We're glad to have you! To get started, ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" begin your free trial")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_6 = { class: "dashboard__content" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dashboard_nav_bar = _resolveComponent("dashboard-nav-bar")!
  const _component_side_nav = _resolveComponent("side-nav")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_banner = _resolveComponent("banner")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dashboard_nav_bar),
    _createElementVNode("main", _hoisted_1, [
      (_ctx.showSideNav)
        ? (_openBlock(), _createBlock(_component_side_nav, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.showBanner)
          ? (_openBlock(), _createBlock(_component_banner, { key: 0 }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_router_link, {
                  class: "anchor--primary",
                  to: `/dashboard/${_ctx.$route.params.subdomain}/billing`
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["to"]),
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.showTitle)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_ctx.$route.name), 1))
            : _createCommentVNode("", true),
          (_ctx.$route.params.subdomain && _ctx.currentOrg)
            ? (_openBlock(), _createBlock(_component_router_view, {
                key: _ctx.currentOrg.id
              }))
            : (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
        ])
      ])
    ])
  ], 64))
}